var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('Container',[_c('div',{staticClass:"pa-a ta-c fs-more tc-g5",staticStyle:{"margin-top":"100px"}},[_vm._v("\n            "+_vm._s(_vm.tipsMsg)+"\n        ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }